export default __webpack_public_path__ + "static/tca-hub-bf92f84006e27fb75f631a14ee973b11.webp";